import * as React from 'react';

const WheelchairSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M13.1 8.4c.2-.3.5-.4.9-.4.2 0 .4.1.6.2.2.1.4.4.4.6 0 .3 0 .5-.2.8l-.8 1.2-.2.2c-.6-.4-1.3-.7-2-.9l1.3-1.7zm1.5 3.2l1-1.5c.7-.9.5-2.2-.5-2.8 0 0-.1 0-.1-.1l-3-2.1-.8-.6-.6.8-2 2.6.8.6 2-2.6 1.8 1.3c-.3.1-.7.4-.9.7L10.6 10c-1.5-.1-3.1.4-4.4 1.4l.8.7c2.1-1.6 5.1-1.5 7 .3 1.9 1.8 2 4.7.4 6.7l.7.7c1.5-1.7 1.9-3.9 1.1-5.9H19v4h1v-5h-4.3c-.3-.5-.6-.9-1-1.2l-.1-.1zM6.6 19.5c-1.8-1.7-2-4.4-.7-6.3l-.8-.7c-1.8 2.3-1.5 5.6.7 7.7 2.2 2.1 5.6 2.3 8.1.6l-.8-.7c-1.9 1.4-4.7 1.1-6.5-.6zM17.4 2c-1.4 0-2.6 1.1-2.6 2.6 0 1.4 1.2 2.6 2.6 2.6S20 6 20 4.6C20 3.1 18.8 2 17.4 2zm0 4.1c-.9 0-1.6-.7-1.6-1.5s.7-1.5 1.6-1.5 1.6.6 1.6 1.5c0 .8-.8 1.5-1.6 1.5z"
        />
    </svg>
);

WheelchairSvg.displayName = 'WheelchairSvg';
export default WheelchairSvg;
